import CouponMasterNewPage from "@/main/components/features/coupon_masters/new/CouponMasterNewPage"

const CouponMasterNew = () => {
	return <CouponMasterNewPage />
}

export default CouponMasterNew
